function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheck, faCog, faCopy, faEllipsisV, faRefresh, faVialVirus } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SocketContext } from '../providers/SocketProvider';
import { generateTestChatMessages } from '@/lib/socket-client';
import { useClipboard, useDisclosure } from '@mantine/hooks';
import { ActionIcon, Menu, MenuDivider, MenuDropdown } from '@mantine/core';
import Icon, { IconSizes } from '../Icon';
import InputModal from '../InputModal';
function getEntryUserName(param) {
    var name = param.name, displayName = param.displayName;
    if (name.toLowerCase() === displayName.toLowerCase()) {
        return displayName;
    }
    return "".concat(displayName, " (").concat(name, ")");
}
export default function GiveawayMenu(param) {
    var onReset = param.onReset, onEditGiveaway = param.onEditGiveaway, users = param.users, entries = param.entries, guesses = param.guesses;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(false), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(''), 2), copyEntriesText = _React_useState1[0], setCopyEntriesText = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(''), 2), copyGuessesText = _React_useState2[0], setCopyGuessesText = _React_useState2[1];
    var socket = React.useContext(SocketContext);
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), generateTestEntries = _React_useState3[0], setGenerateTestEntries = _React_useState3[1];
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), resetModalOpen = _useDisclosure[0], resetModalHandlers = _useDisclosure[1];
    useEffect(function() {
        if (!open) {
            return;
        }
        if (users == null || entries == null || entries.length === 0) {
            setCopyEntriesText(null);
            return;
        }
        // for better performance, we delay the copy text generation to the next tick
        var timeout = setTimeout(function() {
            setCopyEntriesText(entries.map(function(entry) {
                return users.get(entry);
            }).filter(function(user) {
                return (user === null || user === void 0 ? void 0 : user.eligible) === true;
            }).map(function(user) {
                return getEntryUserName(user);
            }).join('\n'));
        }, 0);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        open,
        entries,
        users
    ]);
    useEffect(function() {
        if (!open) {
            return;
        }
        if (guesses == null || guesses.length === 0) {
            setCopyGuessesText(null);
            return;
        }
        // for better performance, we delay the copy text generation to the next tick
        var timeout = setTimeout(function() {
            setCopyGuessesText(guesses.map(function(param) {
                var user = param.user, guess = param.guess;
                return "".concat(user.displayName, " (").concat(user.name, "): ").concat(guess);
            }).join('\n'));
        }, 0);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        open,
        guesses
    ]);
    useEffect(function() {
        if (!generateTestEntries || socket == null) {
            return;
        }
        var interval = setInterval(function() {
            generateTestChatMessages(socket);
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        generateTestEntries,
        socket
    ]);
    var _useClipboard = useClipboard(), copy = _useClipboard.copy, copied = _useClipboard.copied;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Menu, {
                position: "bottom-end",
                closeOnItemClick: false,
                onOpen: function() {
                    return setOpen(true);
                },
                onExitTransitionEnd: function() {
                    setCopyEntriesText(null);
                    setCopyGuessesText(null);
                },
                children: [
                    /*#__PURE__*/ _jsx(Menu.Target, {
                        children: /*#__PURE__*/ _jsx(ActionIcon, {
                            children: /*#__PURE__*/ _jsx(Icon, {
                                icon: faEllipsisV
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(MenuDropdown, {
                        children: [
                            onEditGiveaway != null ? /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Menu.Item, {
                                        closeMenuOnClick: true,
                                        leftSection: /*#__PURE__*/ _jsx(Icon, {
                                            size: IconSizes.SM,
                                            icon: faCog
                                        }),
                                        onClick: onEditGiveaway,
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "Bw7469",
                                            defaultMessage: "Giveaway Options"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(MenuDivider, {})
                                ]
                            }) : null,
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                closeMenuOnClick: true,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faRefresh
                                }),
                                onClick: resetModalHandlers.open,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "pPHzS5",
                                    defaultMessage: "Reset Entries"
                                })
                            }),
                            guesses != null ? /*#__PURE__*/ _jsx(Menu.Item, {
                                disabled: guesses.length === 0,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: copied ? faCheck : faCopy
                                }),
                                onClick: function() {
                                    return copy(copyGuessesText);
                                },
                                children: copied ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "2BfifT",
                                    defaultMessage: "Copied all"
                                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "NlemKy",
                                    defaultMessage: "Copy Guesses"
                                })
                            }) : null,
                            entries != null ? /*#__PURE__*/ _jsx(Menu.Item, {
                                disabled: entries.length === 0,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: copied ? faCheck : faCopy
                                }),
                                onClick: function() {
                                    return copy(copyEntriesText);
                                },
                                children: copied ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "2BfifT",
                                    defaultMessage: "Copied all"
                                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "WeNI+7",
                                    defaultMessage: "Copy Eligible Entries"
                                })
                            }) : null,
                            process.env.NODE_ENV === 'development' ? /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(MenuDivider, {}),
                                    /*#__PURE__*/ _jsx(Menu.Item, {
                                        leftSection: /*#__PURE__*/ _jsx(Icon, {
                                            size: IconSizes.SM,
                                            icon: faVialVirus
                                        }),
                                        onClick: function() {
                                            return setGenerateTestEntries(true);
                                        },
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "LDvJBd",
                                            defaultMessage: "Generate Test Entries"
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: resetModalOpen,
                title: intl.formatMessage({
                    id: "pPHzS5",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset Entries"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "ATZ87R",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to reset all entries?"
                        }
                    ]
                }),
                onSubmit: onReset,
                onClose: resetModalHandlers.close,
                submitText: intl.formatMessage({
                    id: "jm/spn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset"
                        }
                    ]
                })
            })
        ]
    });
}
